import { IEmail } from "@/types/common";
import React, { useState } from "react";
import BaseDialog from "@/components/BaseDialog";
import { Box, Button, Center, Flex, HStack, Stack, Text, VStack } from "@chakra-ui/react";
import downloadIcon from "@/assets/DownloadIcon.svg";
import { formatFileSize } from "@/utils/common";
import { resolveMediaUrl } from "@/utils/resolveMediaUrl";

const ViewContentDialogButton = ({ field }: { field: IEmail }) => {
  const [open, setOpen] = useState(false);

  const handleDownload = async (file: {
    file: { url: string };
    filename: string;
  }) => {
    const response = await fetch(resolveMediaUrl(file.file.url));
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = file.filename;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  
  return (
    <BaseDialog
      trigger={
        <Text
          color='brand.solid'
          cursor="pointer"
        >
          Click to view
        </Text>
      }
      title={"Email content"}
      actionButtons={
        <Button variant="outline" onClick={() => setOpen(false)}>
          Close
        </Button>
      }
      open={open}
      setOpen={setOpen}
    >
      <Stack
        gap={4}
      >
        <Stack gap={3} my={2}>
          <Text
            fontSize='lg'
            letterSpacing='wide'
            color='primary'
          >
            Sender: {field?.sender}
          </Text>
          <Text
            fontSize='lg'
            letterSpacing='wide'
            color='primary'
          >
            {field?.subject}
          </Text>
        </Stack>
        <Flex
          p={2.5}
          border="1px solid"
          borderColor="border"
          rounded="md"
          order={1}
        >
          {field?.body}
        </Flex>
        {field?.files && field?.files.length > 0 && (
          <Stack
            width="100%"
            p={2}
            border="1px solid"
            borderColor="border"
            rounded="md"
            order={1}
          >
            <Text>Attachments ({field?.files.length})</Text>
            {field?.files?.map((file) => (
              <Flex
                gap={2}
                alignItems="center"
                key={file.id}
              >
                  <Flex
                    alignItems="center"
                    height={27}
                    px={2.5}
                    width="100%"
                    bg="rgba(253, 234, 234, 0.5)"
                    borderRadius="lg"
                  >
                    {file.filename} ({formatFileSize(file.size)})
                  </Flex>
                  <Center
                    display="flex"
                    width={25}
                    height={25}
                    bg="text.subtle"
                    borderRadius="lg"
                    cursor={"pointer"}
                    order={1}
                    onClick={() => {
                      handleDownload(file);
                    }}
                  >
                    <img
                      src={downloadIcon}
                      alt="Download icon"
                      width="19"
                      height="19"
                    />
                  </Center>
              </Flex>
            ))}
          </Stack>
        )}
      </Stack>
    </BaseDialog>
  );
};

export default ViewContentDialogButton;
